import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 rolesListData:[]
};

const rolesListSlice = createSlice({
  name: 'rolesDetails',
  initialState,
  reducers: {
    rolesListDataFunc: (state, action) => {
      state.rolesListData = action.payload;
    },
    
  },
});

export const { rolesListDataFunc } = rolesListSlice.actions;

export default rolesListSlice.reducer;
